<template>
  <ul>
    <template v-if="categories">
      <li v-for="(category, index) in categories" :key="index">
        <CategoryItem v-if="category.slug" :category="category" />
      </li>
    </template>
    <template v-else>
      <li v-for="b in 5" :key="b">
        <div class="link" />
      </li>
    </template>
    <li v-if="!hasChildren && link && !noMoreButton" class="all-product">
      <UiLinkTriangle
        :url="`/${link}/`"
        title="Смотреть все товары"
        color="#242424"
      />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import CategoryItem from '~/components/category-item/category-item.vue';

defineProps({
  categories: {
    type: Array,
    default: () => [],
  },
  hasChildren: {
    type: Boolean,
    default: true,
  },
  noMoreButton: {
    type: Boolean,
    default: false,
  },
  link: {
    type: String,
    default: '',
  },
});
</script>
<style scoped lang="scss">
ul {
  display: grid;
  grid-template-columns: 100%;
  grid-auto-rows: auto;
  border-radius: 8px;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  margin: 0;
  @include sm-block {
    grid-template-columns: repeat(2, 1fr);
  }
  @include md-block {
    grid-template-columns: repeat(3, 1fr);
  }
  @include lg-block {
    grid-template-columns: repeat(4, 1fr);
  }
  @include xl-block {
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 16px;
    grid-row-gap: 16px;
  }
}

li {
  background: $achromatic-card-bg;
  border-radius: 8px;
  width: 100%;
  margin: 0;

  .all-product :deep(.text_a) {
    color: $achromatic-black;
    font-size: 12px;
    line-height: 16px;

    @include xl-block {
      font-size: 14px;
      line-height: 20px;
    }
  }

  .link {
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    line-height: 1.4;
    color: inherit;
    text-decoration: none;
    height: 72px;
    padding: 16px;
    font-size: 12px;

    @include lg-block {
      height: 84px;
    }

    @include xl-block {
      height: 92px;
      font-size: 14px;
      padding: 20px;
    }
  }

  .img {
    position: relative;
    background: white;
    width: 32px;
    height: 32px;
    min-height: 32px;
    min-width: 32px;
    margin-left: 20px;

    @include xl-block {
      height: 48px;
      width: 48px;
      min-height: 48px;
      min-width: 48px;
      margin-left: 25px;
    }

    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.04);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .category-all {
    position: relative;
    display: inline-block;
  }

  .category-all:after {
    position: absolute;
    content: '';
    display: block;
    -webkit-mask: url('/static/images/icon/triangle.svg') center/contain
      no-repeat;
    mask: url('/static/images/icon/triangle.svg') center/contain no-repeat;
    width: 24px;
    height: 24px;
    background-color: $achromatic-black;
    transform: rotate(-90deg);
    right: -28px;
    top: -4px;

    @include xl-block {
      top: -3px;
    }
  }
}
</style>
